/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PartialRole } from './PartialRole';
import {
    PartialRoleFromJSON,
    PartialRoleFromJSONTyped,
    PartialRoleToJSON,
} from './PartialRole';
import type { Property } from './Property';
import {
    PropertyFromJSON,
    PropertyFromJSONTyped,
    PropertyToJSON,
} from './Property';

/**
 * 
 * @export
 * @interface BigRock
 */
export interface BigRock {
    /**
     * 
     * @type {string}
     * @memberof BigRock
     */
    name: string;
    /**
     * 
     * @type {PartialRole}
     * @memberof BigRock
     */
    roleOn?: PartialRole;
    /**
     * 
     * @type {PartialRole}
     * @memberof BigRock
     */
    roleOff?: PartialRole;
    /**
     * 
     * @type {PartialRole}
     * @memberof BigRock
     */
    groupRockRole?: PartialRole;
    /**
     * 
     * @type {Array<Property>}
     * @memberof BigRock
     */
    properties?: Array<Property>;
    /**
     * 
     * @type {Array<Property>}
     * @memberof BigRock
     */
    propertiesSet?: Array<Property>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BigRock
     */
    destiny?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof BigRock
     */
    enabledGroupIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof BigRock
     */
    disabledGroupIds?: Array<number>;
    /**
     * 
     * @type {Array<BigRock>}
     * @memberof BigRock
     */
    subRocks?: Array<BigRock>;
    /**
     * 
     * @type {boolean}
     * @memberof BigRock
     */
    isSubRock?: boolean;
}

/**
 * Check if a given object implements the BigRock interface.
 */
export function instanceOfBigRock(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function BigRockFromJSON(json: any): BigRock {
    return BigRockFromJSONTyped(json, false);
}

export function BigRockFromJSONTyped(json: any, ignoreDiscriminator: boolean): BigRock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'roleOn': !exists(json, 'role_on') ? undefined : PartialRoleFromJSON(json['role_on']),
        'roleOff': !exists(json, 'role_off') ? undefined : PartialRoleFromJSON(json['role_off']),
        'groupRockRole': !exists(json, 'group_rock_role') ? undefined : PartialRoleFromJSON(json['group_rock_role']),
        'properties': !exists(json, 'properties') ? undefined : ((json['properties'] as Array<any>).map(PropertyFromJSON)),
        'propertiesSet': !exists(json, 'properties_set') ? undefined : ((json['properties_set'] as Array<any>).map(PropertyFromJSON)),
        'destiny': !exists(json, 'destiny') ? undefined : json['destiny'],
        'enabledGroupIds': !exists(json, 'enabled_group_ids') ? undefined : json['enabled_group_ids'],
        'disabledGroupIds': !exists(json, 'disabled_group_ids') ? undefined : json['disabled_group_ids'],
        'subRocks': !exists(json, 'sub_rocks') ? undefined : ((json['sub_rocks'] as Array<any>).map(BigRockFromJSON)),
        'isSubRock': !exists(json, 'is_sub_rock') ? undefined : json['is_sub_rock'],
    };
}

export function BigRockToJSON(value?: BigRock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'role_on': PartialRoleToJSON(value.roleOn),
        'role_off': PartialRoleToJSON(value.roleOff),
        'group_rock_role': PartialRoleToJSON(value.groupRockRole),
        'properties': value.properties === undefined ? undefined : ((value.properties as Array<any>).map(PropertyToJSON)),
        'properties_set': value.propertiesSet === undefined ? undefined : ((value.propertiesSet as Array<any>).map(PropertyToJSON)),
        'destiny': value.destiny,
        'enabled_group_ids': value.enabledGroupIds,
        'disabled_group_ids': value.disabledGroupIds,
        'sub_rocks': value.subRocks === undefined ? undefined : ((value.subRocks as Array<any>).map(BigRockToJSON)),
        'is_sub_rock': value.isSubRock,
    };
}

